module.exports = __webpack_public_path__ + "static/media/left_arrow.5eeb5495.svg";